/* Oregano PDP behaviour.
   Lives in assets/ rather than inline in sections/oregano-pdp.liquid because
   that section is a hard 256 KB per file and the inline copy of this script
   put it over — the whole PDP 500'd with "Template content exceeds 256 KB".
   It is plain JS on purpose (not .js.liquid): a Liquid asset is cached once
   for the whole shop, so the cart count it used to interpolate would have
   been one shopper's number served to everybody. That value now arrives on
   .po-pdp[data-cart-count] instead. */
(function(){
  var root = document.querySelector('.po-pdp');
  if(!root) return;

  /* Each feature runs isolated. Previously one IIFE meant a throw in an early
     block (a missing #po-timer, a gallery with no images) silently killed
     every feature below it — the FAQ and counters would just stop working
     with no visible cause. */
  function safe(name, fn){
    try { fn(); }
    catch(err){ if(window.console) console.warn('[oregano-pdp] ' + name + ' failed:', err); }
  }

  /* The gift-unlock offer (?view=newoffer, section setting offer_mode=unlock)
     replaces the Kaching selector with its own tier cards. When it is on the
     page it, not Kaching, is the source of truth for the offer — so the two
     blocks below that read Kaching's config or check out on their own defer
     to it. See snippets/po-offer-unlock.liquid. */
  var unlock = root.querySelector('.pou');

  safe('layout-compare', function(){
  /* ---- TEMPORARY: ?lay=rows / ?lay=rail flips the compounds mechanism layout
     so the two can be compared on the same page without a redeploy. Delete this
     block (and the losing layout's CSS) once one is picked. ---- */
  var lay = new URLSearchParams(location.search).get('lay');
  var comp = root.querySelector('.po-comp');
  if(comp && (lay === 'rows' || lay === 'rail')) comp.setAttribute('data-lay', lay);
  });

  safe('countdown', function(){
  /* ---- countdown: resets daily so it never shows a dead timer ---- */
  var t = root.querySelector('#po-timer');
  if(t){
    var h=t.querySelector('[data-h]'), m=t.querySelector('[data-m]'), s=t.querySelector('[data-s]');
    var pad=function(n){return n<10?'0'+n:''+n;};
    var tick=function(){
      var now=new Date(), end=new Date(now);
      end.setHours(24,0,0,0);
      var d=Math.max(0,Math.floor((end-now)/1000));
      h.textContent=pad(Math.floor(d/3600));
      m.textContent=pad(Math.floor(d%3600/60));
      s.textContent=pad(d%60);
    };
    tick(); setInterval(tick,1000);
  }
  });

  safe('gallery', function(){
  /* ---- gallery ----
     The thumbs are the source of truth for "which image is showing" — the arrows
     just move the index and reuse the same show() path, so there is only one
     place that can get the srcset/aria-current bookkeeping wrong. Wraps at both
     ends: five thumbs is short enough that a dead arrow reads as broken. */
  var main = root.querySelector('#po-gal-img');
  var thumbs = [].slice.call(root.querySelectorAll('.po-thumb'));
  if(!main || !thumbs.length) return;

  function show(i){
    var btn = thumbs[(i + thumbs.length) % thumbs.length];
    main.removeAttribute('srcset');
    main.src = btn.dataset.full;
    thumbs.forEach(function(b){ b.setAttribute('aria-current','false'); });
    btn.setAttribute('aria-current','true');
  }
  function current(){
    var i = thumbs.findIndex(function(b){ return b.getAttribute('aria-current') === 'true'; });
    return i < 0 ? 0 : i;
  }

  thumbs.forEach(function(btn,i){
    btn.addEventListener('click', function(){ show(i); });
  });
  root.querySelectorAll('[data-gnav]').forEach(function(btn){
    btn.addEventListener('click', function(){
      show(current() + parseInt(btn.dataset.gnav, 10));
    });
  });
  });

  safe('sticky-bar', function(){
  /* ---- sticky bar once the main buy box scrolls away ---- */
  var form = root.querySelector('#po-form'), sticky = root.querySelector('#po-sticky');
  if(form && sticky && 'IntersectionObserver' in window){
    new IntersectionObserver(function(e){
      sticky.classList.toggle('po-on', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
    },{threshold:0}).observe(form);
  }
  });

  safe('benefit carousel', function(){
  /* ---- benefit cards: dots + arrows for the mobile snap rail ----
     The rail scrolls natively; this only reflects and drives position. The
     controls ship `hidden` and are unhidden here, so a browser that throws
     before this point gets a plain swipeable row rather than dead buttons.

     Everything reads scrollLeft — no index counter of our own. A swipe, an
     arrow, a dot and a keyboard scroll all move the same one number, and a
     second source of truth would drift out of sync with the first one to
     move. */
  var rail = root.querySelector('.po-ben');
  var nav  = root.querySelector('[data-po-ben-nav]');
  if(!rail || !nav) return;
  var cards = rail.querySelectorAll('.po-ben-c');
  var dots  = nav.querySelectorAll('.po-ben-dot');
  var prev  = nav.querySelector('[data-po-ben-prev]');
  var next  = nav.querySelector('[data-po-ben-next]');
  if(!cards.length || dots.length !== cards.length) return;
  nav.hidden = false;

  /* Distance from a card's left edge to where a snapped card sits — the
     rail's left inset by its scroll-padding. Measured with rects rather
     than offsetLeft: .po-ben is not a positioned element, so the cards'
     offsetParent is some ancestor further up and their offsetLeft is not in
     the rail's scroll coordinates. Rects are, once scrollLeft is added
     back.

     Card width is a vw expression and the last card stops short of a full
     step at the end of the scroll, so this measures rather than multiplying
     out a fixed step. */
  function delta(card){
    var pad = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
    return card.getBoundingClientRect().left - rail.getBoundingClientRect().left - pad;
  }

  function current(){
    var best = 0, gap = Infinity;
    for(var i = 0; i < cards.length; i++){
      var d = Math.abs(delta(cards[i]));
      if(d < gap){ gap = d; best = i; }
    }
    return best;
  }

  /*
    Paging is animated by hand instead of `scrollTo({behavior:'smooth'})`.
    Measured on this rail: the very first smooth scroll lands, and every one
    after it is silently dropped — the scroller sits where it is and the
    dots freeze with it. `scroll-snap-type:x mandatory` is what kills them;
    instant scrolls on the same element work fine. So snap comes off for the
    duration of the glide and goes back on at the end, where it does the job
    it is actually there for: catching a thumb swipe.

    ~380ms with an ease-in-out. This is a click response, not a loop — it
    runs once and stops, unlike the marquee rAF that used to drive this row.
  */
  var glide = 0;
  function go(i){
    i = Math.max(0, Math.min(cards.length - 1, i));
    var from = rail.scrollLeft, dist = delta(cards[i]), t0 = 0, ms = 380;
    if(!dist) return;
    if(glide) cancelAnimationFrame(glide);
    rail.style.scrollSnapType = 'none';
    glide = requestAnimationFrame(function step(now){
      if(!t0) t0 = now;
      var p = Math.min(1, (now - t0) / ms);
      var e = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      rail.scrollLeft = from + dist * e;
      if(p < 1){ glide = requestAnimationFrame(step); }
      else { glide = 0; rail.style.scrollSnapType = ''; }
    });
  }

  function sync(){
    var i = current();
    for(var d = 0; d < dots.length; d++) dots[d].setAttribute('aria-selected', d === i ? 'true' : 'false');
    /* Compare against the real scroll extent, not the index: at the far end
       the last card can be fully in view while `current()` still reports the
       one before it, and a live-looking arrow that cannot move is worse than
       a greyed one. */
    if(prev) prev.disabled = rail.scrollLeft <= 1;
    if(next) next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 1;
  }

  if(prev) prev.addEventListener('click', function(){ go(current() - 1); });
  if(next) next.addEventListener('click', function(){ go(current() + 1); });
  for(var d = 0; d < dots.length; d++){
    (function(i){ dots[i].addEventListener('click', function(){ go(i); }); })(d);
  }

  var tick = 0;
  rail.addEventListener('scroll', function(){
    if(tick) return;
    tick = requestAnimationFrame(function(){ tick = 0; sync(); });
  }, { passive: true });
  window.addEventListener('resize', sync);
  sync();
  });

  /*
    The "offer ladder" mirror used to live here: it rebuilt the tier cards from
    Kaching's rendered bars and, on click, clicked Kaching's <label> and then
    the hero's Add To Cart. It is gone because it could not do the one thing it
    was there for. The hero form posts a fixed variant id, so selecting a bar
    changed only Kaching's own properties payload and every tier checked out as
    Buy 1 Get 1 Free. The cards are Liquid now, one variant per card — see the
    offer ladder markup above.
  */

  safe('tier sync', function(){
  /* ---- keep the offer ladder locked to the Kaching bars ----
     The hero's "BUNDLE & SAVE" selector is the Kaching Bundles app; the ladder
     down the page is ours. They were two hand-maintained copies of the same
     offer, so of course they drifted: Kaching was switched to
     B1G1 / B2G2 / B3G3 and the ladder kept selling BUY 1 / B1G1 / B2G2 —
     wrong names, wrong day counts, a tier that no longer exists up top.

     Kaching renders its whole offer config into the page as JSON before our
     script runs (`script.kaching-bundles-deal-block-settings`), including the
     ordered bars, which bar is preselected, and — in `defaultVariantsV2` — the
     variant each bar buys for this product. That is everything the ladder
     needs except price, which we take from the Liquid table above so it stays
     market-correct.

     So: change the offer in the Kaching admin, and the ladder follows on the
     next page load. No theme edit, nothing to keep in sync by hand.

     If anything is missing — app embed off, config shape changed, no variant
     mapped — this bails and the Liquid-rendered ladder stands. A slightly
     stale ladder beats an empty one. */
  /* In gift-unlock mode the buy box no longer runs on Kaching, so rebuilding
     the ladder from Kaching's config would quote the OLD offer next to the new
     one. The Liquid-rendered ladder already matches, so leave it alone. */
  if(unlock) return;

  var wrap = root.querySelector('[data-po-tiers]');
  var data = root.querySelector('[data-po-variants]');
  if(!wrap || !data) return;

  var pid = parseInt(wrap.getAttribute('data-po-product'), 10);
  var table = JSON.parse(data.textContent);
  var byId = {};
  (table.variants || []).forEach(function(v){ byId[v.id] = v; });

  var cfgEl = document.querySelector('script.kaching-bundles-deal-block-settings[data-product-id="' + pid + '"]')
           || document.querySelector('script.kaching-bundles-deal-block-settings');
  if(!cfgEl) return;

  var cfg = JSON.parse(cfgEl.textContent);
  var bars = cfg.dealBars || [];
  if(!bars.length) return;

  /* One product can appear more than once in defaultVariantsV2 (the same bars
     are reused across products), so filter to this product and take the first
     variant each bar maps to. */
  var barVariant = {};
  (cfg.defaultVariantsV2 || []).forEach(function(d){
    if(parseInt(d.productGID, 10) !== pid) return;
    if(!d.variantGIDs || !d.variantGIDs.length) return;
    if(!(d.dealBarId in barVariant)) barVariant[d.dealBarId] = parseInt(d.variantGIDs[0], 10);
  });

  var tiers = [];
  bars.forEach(function(bar){
    var v = byId[barVariant[bar.id]];
    if(!v || !v.available) return;
    tiers.push({ bar: bar, v: v });
  });
  if(!tiers.length) return;

  /* How many pouches ship, for the pack shot. Variant titles carry it
     explicitly ("60 Softgels x 4"); otherwise read it off the offer name,
     where "Buy 2 Get 2 Free" means four. */
  function packs(t){
    var m = t.title.match(/[x×]\s*(\d+)/i);
    if(m) return parseInt(m[1], 10);
    m = t.bar.match(/buy\s*(\d+)\s*get\s*(\d+)/i);
    if(m) return parseInt(m[1], 10) + parseInt(m[2], 10);
    m = t.bar.match(/buy\s*(\d+)/i);
    return m ? parseInt(m[1], 10) : 1;
  }
  function packImage(n){
    var imgs = table.packImages || {};
    if(imgs[n]) return imgs[n];
    /* No art for this size yet — step down to the largest one we do have
       rather than shipping a broken <img>. */
    var best = null;
    Object.keys(imgs).forEach(function(k){
      var kn = parseInt(k, 10);
      if(kn <= n && (best === null || kn > best)) best = kn;
    });
    return best === null ? '' : imgs[best];
  }
  function words(n){
    return ['', 'one pack', 'two packs', 'three packs', 'four packs',
            'five packs', 'six packs'][n] || (n + ' packs');
  }

  var frag = document.createDocumentFragment();
  tiers.forEach(function(t){
    var v = t.v;
    var isBest = t.bar.id === cfg.preselectedDealBarId;
    var name = String(t.bar.title || v.title);
    var sub  = String(t.bar.subtitle || '');
    var priceText = v.planId ? v.planPriceText : v.priceText;
    var showWas = v.planId && v.price > v.planPrice;
    var n = packs({ title: v.title, bar: name });

    var a = document.createElement('a');
    a.className = 'po-tier' + (isBest ? ' po-tier-best' : '');
    a.href = '#po-form';
    a.setAttribute('data-po-buy', v.id);
    if(v.planId) a.setAttribute('data-po-plan', v.planId);
    a.setAttribute('aria-label', name + ' — ' + sub.replace(/[()]/g, '').trim() +
      ' — ' + priceText + ' — go to checkout');

    if(isBest){
      var rib = document.createElement('div');
      rib.className = 'po-ribbon';
      rib.textContent = 'Most Popular';
      a.appendChild(rib);
    }

    var img = document.createElement('img');
    img.className = 'po-tier-img';
    img.src = packImage(n);
    img.width = 500; img.height = 520;
    img.loading = 'lazy'; img.decoding = 'async';
    img.alt = words(n) + ' of Pure Oregano oil of oregano';
    a.appendChild(img);

    var body = document.createElement('div');
    body.className = 'po-tier-body';
    /* textContent throughout — the names come from a third-party admin field
       and must never be able to inject markup into this page. */
    var el = document.createElement('div');
    el.className = 'po-tier-name'; el.textContent = name; body.appendChild(el);
    el = document.createElement('div');
    el.className = 'po-tier-sub'; el.textContent = sub; body.appendChild(el);
    el = document.createElement('div');
    el.className = 'po-tier-price'; el.textContent = priceText; body.appendChild(el);
    if(showWas){
      var per = document.createElement('div');
      per.className = 'po-tier-per';
      var was = document.createElement('span');
      was.className = 'po-tier-was'; was.textContent = v.priceText;
      per.appendChild(was); body.appendChild(per);
    }
    a.appendChild(body);
    frag.appendChild(a);
  });

  wrap.textContent = '';
  wrap.appendChild(frag);

  /* The other two places the offer is named in copy. Same source, same reason:
     they were still advertising a ladder that had moved on. */
  function titly(str){
    return String(str).toLowerCase().replace(/\b[a-z]/g, function(c){ return c.toUpperCase(); });
  }
  var cheapest = titly(tiers[0].bar.title), dearest = titly(tiers[tiers.length - 1].bar.title);
  var barSub = root.querySelector('.po-bar-sub');
  if(barSub && tiers.length > 1) barSub.textContent = 'Up to ' + dearest;
  var stickyName = root.querySelector('.po-sticky-t b');
  var stickyAlt = root.querySelector('.po-sticky-t span');
  if(stickyName) stickyName.textContent = cheapest;
  if(stickyAlt && tiers.length > 1) stickyAlt.textContent = 'or ' + dearest;
  });

  safe('tier checkout', function(){
  /*
    ---- why this is JS and not a plain cart permalink ----
    The cards were `href="/cart/{variant}:1?selling_plan={id}"`. That shipped to
    live and was wrong: Shopify accepts the permalink, adds the right variant,
    and SILENTLY DROPS the selling_plan. The tier advertising Rs9,400 built a
    checkout for Rs12,500 — the plain one-time price — with no subscription and
    no recurring line. Caught on live by reading the actual checkout, not the
    redirect: the permalink 302s happily and the variant is correct, so
    everything looks fine until you compare the total against the card.

    /cart/add.js honours `selling_plan` where the permalink does not, so the
    click adds through the API and then goes to checkout. Verified both ways on
    the live store: permalink -> Rs12,500 plan:null, add.js -> Rs9,400 plan set.

    The cart is cleared first so a tier means "buy THIS bundle" rather than
    appending to whatever was already in the cart — matching what the permalink
    used to do. `href="#po-form"` is the no-JS fallback: it drops the shopper at
    the buy box, which is worse UX than a direct checkout but cannot overcharge
    anyone, which the permalink could.
  */
  var tiers = root.querySelectorAll('[data-po-tiers] [data-po-buy]');
  if(!tiers.length) return;

  /* ---- gift-unlock mode ----
     Checking out straight from a ladder card would post the bundle WITHOUT the
     free gifts that card is advertising — the shopper would be charged the
     right price and receive nothing extra. So instead the card selects the
     matching tier in the buy box and scrolls the reader up to it, where the
     unlocked gifts are visible and the real add-to-cart lives. */
  if(unlock){
    var pouCards = unlock.querySelectorAll('.pou-card');
    Array.prototype.forEach.call(tiers, function(a){
      a.addEventListener('click', function(e){
        if(e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
        var id = String(a.dataset.poBuy);
        var match = null;
        Array.prototype.forEach.call(pouCards, function(c){
          if(c.getAttribute('data-variant') === id) match = c;
        });
        e.preventDefault();
        if(match) match.click();
        var target = unlock.getBoundingClientRect();
        window.scrollTo({ top: Math.max(0, target.top + window.pageYOffset - 16), behavior: 'smooth' });
        if(history.replaceState) history.replaceState(null, '', '#po-form');
      });
    });
    return;
  }

  /*
    ---- why the clear is conditional ----
    Measured on the live store: clear.js 1098ms, add.js 1238ms, checkout
    document 825ms. Clearing unconditionally put a full second of dead time in
    front of every checkout for no benefit, because the overwhelming majority
    of shoppers on a single-product lander arrive with an empty cart and there
    is nothing to clear.

    So the cart is only cleared when there is something in it. `cart.item_count`
    is rendered server-side at page load, and the flag is flipped to true after
    our own first add — so clicking a second tier still REPLACES the first
    rather than stacking two bundles into one order, which is the thing the
    clear was protecting against.
  */
  var cartDirty = Number(root.dataset.cartCount || 0) > 0;

  var post = function(url, body){
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  };

  Array.prototype.forEach.call(tiers, function(a){
    a.addEventListener('click', function(e){
      if(e.metaKey || e.ctrlKey || e.shiftKey || e.button) return; /* let modified clicks be */
      e.preventDefault();
      if(a.dataset.poBusy) return;
      a.dataset.poBusy = '1';
      /* Something has to happen on the press. Even at its fastest this is a
         second of network before the browser starts navigating, and a card
         that just sits there reads as a dead button and gets clicked again. */
      a.classList.add('po-tier-loading');

      var item = { id: Number(a.dataset.poBuy), quantity: 1 };
      if(a.dataset.poPlan) item.selling_plan = Number(a.dataset.poPlan);

      var start = cartDirty ? post('/cart/clear.js', {}) : Promise.resolve();

      start
        .then(function(){ return post('/cart/add.js', { items: [item] }); })
        .then(function(r){ if(!r.ok) throw new Error('add failed ' + r.status); })
        .then(function(){
          cartDirty = true;
          /* A one-time tier sold through a hidden code: /discount/CODE
             attaches it, then forwards to checkout. */
          var code = (a.dataset.poCode || '').trim();
          window.location.href = code
            ? '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcheckout'
            : '/checkout';
        })
        .catch(function(){
          /* Never strand the shopper on a dead card — fall back to the buy box
             rather than to a permalink that would quote the wrong price. */
          a.dataset.poBusy = '';
          a.classList.remove('po-tier-loading');
          window.location.hash = 'po-form';
        });
    });
  });
  });

  safe('offer jump', function(){
  /* ---- what the "choose a bundle" CTAs actually scroll to ----
     Every CTA on the page is `href="#po-form"`, and that was landing people
     in the wrong place. #po-form is only the 61px <form> holding the hidden
     inputs and the Add-to-cart button; Kaching injects its selector as a
     SIBLING ABOVE it. Measured on the lander product: bundle bars occupy
     691-1161, the form starts at 1185. A native anchor jump puts the form's
     top edge at the viewport top, which leaves the entire selector 463px
     off-screen — you get sent to "pick your bundle" and arrive at a bare
     button with no bundles in sight.

     So the jump targets the selector when it exists and falls back to the
     form when it doesn't (no Kaching, embed disabled). The href stays as it
     is: without JS a native jump to the form is still roughly the right
     region, and it keeps the link real for middle-click and for a11y.

     Every jump animates, deliberately, including the ~11,000px one from the
     bottom of the page. Worth knowing the trade: the theme sets
     `html{scroll-behavior:smooth}`, a scroll that long runs for seconds on a
     phone, and a touch mid-animation cancels it and leaves the reader
     part-way. Teleporting instead would rule that out, but it also drops
     people onto a screen with no sense of having moved. If the interrupted
     scroll turns out to bite in testing, the fix is to shorten the
     animation, not to remove it. */
  var form = root.querySelector('#po-form');
  if(!form) return;
  var GAP = 16;
  /*
    `:not([data-po-buy])` excludes the offer ladder cards. They carry
    href="#po-form" purely as a no-JS fallback, but this handler matched them
    too — so clicking a tier smooth-scrolled the ~11,000px back to the buy box
    while the checkout was being built, and the shopper watched the whole page
    fly past before the checkout opened. The tier cards do their own thing;
    this handler is only for the "Choose Your Bundle" style CTAs.
  */
  root.querySelectorAll('a[href="#po-form"]:not([data-po-buy])').forEach(function(a){
    a.addEventListener('click', function(e){
      var target = root.querySelector('kaching-bundle') || form;
      var rect = target.getBoundingClientRect();
      e.preventDefault();
      /* Always animated, however far the jump is — the travel is what tells
         the reader they've been taken back up to the buy box rather than
         dumped on an unfamiliar screen. */
      window.scrollTo({ top: Math.max(0, rect.top + window.pageYOffset - GAP), behavior: 'smooth' });
      /* Keep the URL honest without letting the browser re-jump. */
      if(history.replaceState) history.replaceState(null, '', '#po-form');
    });
  });
  });

  safe('scroll-reveal', function(){
  /* ---- scroll reveal ----
     Two things want the same "in view" signal, so they share one observer:
     `.po-reveal` (opacity-0 until revealed) and `.po-sold`, whose allocation
     meter sits at scaleX(0) until `.po-in` lands on it. (`.po-spec` was the
     third; that block is gone.) */
  var rev = root.querySelectorAll('.po-reveal,.po-sold');
  if(rev.length && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('po-in'); io.unobserve(en.target); }
      });
    },{threshold:.2,rootMargin:'0px 0px -8% 0px'});
    /*
      Stagger comes from each element's own --d (set per group in the markup), NOT
      from a running index over every .po-reveal on the page. With a global index
      the later groups inherited huge delays — adding six comment cards pushed the
      timeline to 540-900ms and it read as "nothing is rendering".
    */
    rev.forEach(function(el){ io.observe(el); });
  } else {
    rev.forEach(function(el){ el.classList.add('po-in'); });
  }
  });

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- animated accordions (FAQ + hero split) ----
     <details> snaps open, so the toggle is intercepted and the wrapper's
     height is animated instead. Height is released to auto once open so a
     long answer can still reflow (fonts loading, window resize). */
  /* Collapse/expand use a forced synchronous reflow to flip height between
     auto and a px value, NOT requestAnimationFrame. rAF is throttled to zero
     in a hidden tab, which would leave a panel pinned at its pixel height and
     never collapsing. A reflow always happens, so the state machine can't
     get stuck; only the CSS transition needs a live frame to look smooth. */
  /* Commits the post-animation state exactly once, on whichever comes first:
     the height transition ending, or a timer just past its duration. The timer
     is not belt-and-braces — transitionend genuinely never fires in a hidden
     tab or if the transition is interrupted, which would leave details.open
     out of sync with what's on screen (a "closed" panel still reported open,
     so the next click did nothing). Any in-flight settle is cancelled first. */
  function settle(w, fn){
    if(w._poSettle) w._poSettle();
    var done = false;
    function fire(){
      if(done) return;
      done = true;
      w.removeEventListener('transitionend', onEnd);
      clearTimeout(timer);
      w._poSettle = null;
      fn();
    }
    function onEnd(e){ if(e.propertyName === 'height') fire(); }
    w.addEventListener('transitionend', onEnd);
    var timer = setTimeout(fire, 420);       /* transition is .34s */
    w._poSettle = fire;
  }

  function expand(d, w){
    d.open = true;
    if(reduce){ w.style.height = 'auto'; return; }
    w.style.height = w.scrollHeight + 'px';
    settle(w, function(){
      if(d.open) w.style.height = 'auto';    /* release so long answers reflow */
    });
  }
  function collapse(d, w){
    if(reduce){ w.style.height = '0px'; d.open = false; return; }
    w.style.height = w.scrollHeight + 'px';  /* pin auto -> px */
    void w.offsetHeight;                     /* flush, so 0px is a transition */
    w.style.height = '0px';
    settle(w, function(){ d.open = false; });
  }

  safe('accordion', function(){
  root.querySelectorAll('.po-faq details, .po-acc details').forEach(function(d){
    var sum = d.querySelector('summary'), w = d.querySelector('.po-anim-w');
    if(!sum || !w) return;

    /* pre-opened panels start at full height */
    if(d.open) w.style.height = 'auto';

    sum.addEventListener('click', function(e){
      e.preventDefault();
      if(d.open){ collapse(d, w); return; }
      /* one panel at a time, scoped to this accordion */
      Array.prototype.forEach.call(d.parentElement.children, function(o){
        if(o === d || o.tagName !== 'DETAILS' || !o.open) return;
        var ow = o.querySelector('.po-anim-w');
        if(ow) collapse(o, ow); else o.open = false;
      });
      expand(d, w);
    });
  });
  });

  safe('count-up', function(){
  /* ---- count-up, shared by the stat rail and the hero dose strip ----
     Each group fires off its own container so the hero strip animates when the
     buy box is read and the rail animates when the rail is reached. A number
     node must be a LEAF (textContent is overwritten every frame) — the "mg"
     units in the dose strip are siblings, not children, for exactly that
     reason. */
  function fmt(v, dec, sep){
    var s = dec ? v.toFixed(dec) : String(Math.round(v));
    if(sep){
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      s = parts.join('.');
    }
    return s;
  }
  function runCount(nums){
    nums.forEach(function(el){
      var to  = parseFloat(el.getAttribute('data-count')),
          dec = parseInt(el.getAttribute('data-dec') || '0', 10),
          sep = el.getAttribute('data-sep') === '1',
          suf = el.getAttribute('data-suffix') || '',
          dly = parseInt(el.getAttribute('data-delay') || '0', 10),
          dur = 1500, t0 = null;
      function frame(ts){
        if(t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1),
            eased = 1 - Math.pow(1 - p, 3);      /* easeOutCubic */
        el.textContent = fmt(to * eased, dec, sep) + suf;
        if(p < 1) requestAnimationFrame(frame);
      }
      el.textContent = fmt(0, dec, sep) + suf;
      if(dly) setTimeout(function(){ requestAnimationFrame(frame); }, dly);
      else requestAnimationFrame(frame);
    });
  }
  /* Only rewind the numbers to 0 when a frame can actually run. In a hidden
     tab rAF never fires, so zeroing them there would strand the rail showing
     "0" once the visitor came back. Defer to the next visibility change. */
  function startCount(nums){
    if(document.hidden){
      document.addEventListener('visibilitychange', function once(){
        if(document.hidden) return;
        document.removeEventListener('visibilitychange', once);
        runCount(nums);
      });
      return;
    }
    runCount(nums);
  }
  function bindCount(sel, numSel){
    var host = root.querySelector(sel);
    var nums = root.querySelectorAll(numSel);
    if(!nums.length || reduce) return;
    if(host && 'IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        if(entries[0].isIntersecting){ io.disconnect(); startCount(nums); }
      },{threshold:.35});
      io.observe(host);
    } else {
      startCount(nums);
    }
  }
  bindCount('.po-stats', '.po-stat b[data-count]');

  /* ---- "What to Expect": scroll-driven progress spine + sticky rail ----
     --p (0..1) is written on the wrapper and consumed by the spine's scaleY and
     the rail's scaleX. Progress is measured against the timeline column, not the
     viewport, so it reads 0 when the first week hits the read line and 1 when the
     last one clears it. */
  (function(){
    var wrap = root.querySelector('[data-exp]');
    if(!wrap) return;
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches){
      wrap.style.setProperty('--p', 1);
      return;
    }
    var list  = wrap.querySelector('.po-exp');
    var items = Array.prototype.slice.call(wrap.querySelectorAll('.po-exp-i'));
    var nowEl = wrap.querySelector('[data-exp-now]');
    var pctEl = wrap.querySelector('[data-exp-pct]');
    var dayEl = wrap.querySelector('[data-exp-day]');
    if(!list || !items.length) return;

    var labels = items.map(function(el){
      var h = el.querySelector('h3');
      return h ? h.textContent.trim() : '';
    });
    var live = -1, queued = false;

    function paint(){
      queued = false;
      var r = list.getBoundingClientRect();
      /* the "read line" sits a bit above centre — where the eye actually is */
      var line = window.innerHeight * 0.42;
      var p = (line - r.top) / (r.height || 1);
      p = p < 0 ? 0 : (p > 1 ? 1 : p);
      wrap.style.setProperty('--p', p.toFixed(4));

      /* which week has the progress head passed? */
      var idx = 0;
      for(var i = 0; i < items.length; i++){
        if(items[i].getBoundingClientRect().top <= line) idx = i;
      }
      if(idx !== live){
        live = idx;
        items.forEach(function(el, i){ el.classList.toggle('is-live', i === idx); });
        if(nowEl && labels[idx]) nowEl.textContent = labels[idx];
      }
      if(pctEl) pctEl.textContent = Math.round(p * 100);
      if(dayEl) dayEl.textContent = Math.max(1, Math.round(p * 60));
    }
    function onScroll(){
      if(queued) return;
      queued = true;
      requestAnimationFrame(paint);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    paint();
  })();

  /* ---- FB comment "Like" — optimistic local toggle, no network ---- */
  root.querySelectorAll('[data-fblike]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var card = btn.closest('.po-fb-c');
      var out = card && card.querySelector('[data-fbcount]');
      if(!out) return;
      var on = btn.getAttribute('aria-pressed') === 'true';
      var n = parseInt(out.textContent, 10) || 0;
      btn.setAttribute('aria-pressed', on ? 'false' : 'true');
      out.textContent = on ? n - 1 : n + 1;
      out.classList.remove('po-bump');
      void out.offsetWidth;            /* restart the keyframe */
      out.classList.add('po-bump');
    });
  });

  /*
    ---- review clamping ----
    Six full-length reviews stacked unclamped ran ~2,400px on a 390px screen —
    nearly three phone-screens of solid grey text, and the single biggest
    "wall of text" on the page.

    The clamp itself is CSS (.po-fb-c:not(.po-open) .po-fb-tx). This only
    decides whether the toggle is worth showing: scrollHeight > clientHeight
    means the clamp actually bit. Measured after fonts settle, because a
    fallback face can wrap to a different line count than Segoe UI and would
    give a false negative here.

    Re-measured on resize (width-only — iOS fires resize on scroll when the
    URL bar collapses, and re-running this on every one of those would fight
    a user who had just expanded a card).
  */
  (function(){
    var cards = root.querySelectorAll('.po-fb-c');
    if(!cards.length) return;

    function sync(){
      cards.forEach(function(card){
        var tx  = card.querySelector('.po-fb-tx');
        var btn = card.querySelector('.po-fb-see');
        if(!tx || !btn) return;
        if(card.classList.contains('po-open')) return;   /* leave expanded cards alone */
        btn.hidden = tx.scrollHeight <= tx.clientHeight + 1;
      });
    }

    cards.forEach(function(card){
      var btn = card.querySelector('.po-fb-see');
      if(!btn) return;
      btn.addEventListener('click', function(){
        var open = card.classList.toggle('po-open');
        btn.textContent = open ? 'See less' : 'See more';
      });
    });

    if(document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
    else sync();
    sync();

    var lastW = window.innerWidth;
    window.addEventListener('resize', function(){
      if(window.innerWidth === lastW) return;            /* ignore iOS URL-bar resizes */
      lastW = window.innerWidth;
      sync();
    });
  })();

  /* ---- video rails: click to play, arrows scroll by one card ---- */
  root.querySelectorAll('[data-vplay]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var fig = btn.closest('.po-vid');
      var vid = fig && fig.querySelector('video');
      if(!vid) return;
      /* only one clip at a time across the whole page */
      root.querySelectorAll('.po-vid.is-playing').forEach(function(other){
        if(other === fig) return;
        var ov = other.querySelector('video');
        if(ov){ ov.pause(); }
        other.classList.remove('is-playing');
      });
      vid.muted = false;
      vid.controls = true;
      fig.classList.add('is-playing');
      var p = vid.play();
      /* if autoplay-with-sound is blocked, fall back to muted so it still plays */
      if(p && p.catch){ p.catch(function(){ vid.muted = true; vid.play().catch(function(){}); }); }
    });
  });
  root.querySelectorAll('.po-vid video').forEach(function(v){
    v.addEventListener('pause', function(){
      var f = v.closest('.po-vid');
      if(f && v.currentTime === 0) f.classList.remove('is-playing');
    });
  });

  /* ---------- lazy video posters ----------
     `<video poster>` has no `loading="lazy"` equivalent: the browser fetches
     every poster on parse, no matter how far down the page the clip sits. Seven
     clips meant ~380 KB of full-size JPEGs downloading during the LCP window
     and starving the hero image of bandwidth. The URL now rides on
     `data-poster` and is promoted to a real `poster` only when the clip is
     within a screen and a half of the viewport. Frames keep their size from
     `.po-vid`'s aspect-ratio, so nothing shifts when the poster lands.

     No IntersectionObserver (or JS off) means every poster is set immediately,
     which is exactly the old behaviour — the page degrades to correct, not broken. */
  (function(){
    var vids = Array.prototype.slice.call(root.querySelectorAll('.po-vid video[data-poster]'));
    if(!vids.length) return;
    function reveal(v){
      var src = v.getAttribute('data-poster');
      if(!src) return;
      v.removeAttribute('data-poster');
      v.setAttribute('poster', src);
    }
    if(!('IntersectionObserver' in window)){ vids.forEach(reveal); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting) return;
        io.unobserve(e.target);
        reveal(e.target);
      });
    }, { rootMargin: '150% 0px' });
    vids.forEach(function(v){ io.observe(v); });
    /* Belt and braces: a tap can beat the observer if someone scrolls fast. */
    root.addEventListener('click', function(ev){
      var btn = ev.target.closest && ev.target.closest('[data-vplay]');
      if(!btn) return;
      var fig = btn.closest('.po-vid');
      var v = fig && fig.querySelector('video[data-poster]');
      if(v){ io.unobserve(v); reveal(v); }
    }, true);
  })();

  /* ---------- auto-advancing rails ----------
     A snap rail only reads as a rail once something has moved. These advance
     one card at a time so the peek resolves into a real second card, and then
     get out of the way: the first deliberate touch, drag, arrow press or key
     stops the timer for the session. It never fights the reader.

     Also idle while the rail is off screen, while the tab is hidden, and while
     a clip inside it is playing — auto-scrolling a rail out from under a video
     someone chose to watch is the one thing worse than not moving at all. */
  var railMotionOK = !window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  /* Read the gap rather than hard-coding it: every rail on this page narrows
     its gap at the mobile breakpoint, and a stale constant walks the target a
     couple of px off the snap point on each advance. Mandatory snap hides that
     today, so this is about not depending on snap to paper over the maths. */
  function railGap(rail){
    var g = parseFloat(getComputedStyle(rail).columnGap);
    return isNaN(g) ? 0 : g;
  }
  function autoRail(rail, cardSel, delay){
    if(!railMotionOK) return;
    var timer = null, seen = false, dead = false, held = 0;

    function scrollable(){ return rail.scrollWidth - rail.clientWidth > 4; }
    function playing(){
      var v = rail.querySelector('video');
      return !!(v && !v.paused && !v.ended);
    }
    function stop(){ if(timer){ clearInterval(timer); timer = null; } }
    function kill(){ dead = true; stop(); }
    function tick(){
      if(!seen || dead || held > performance.now() || document.hidden || !scrollable() || playing()) return;
      var card = rail.querySelector(cardSel);
      var w = card ? card.getBoundingClientRect().width + railGap(rail) : rail.clientWidth;
      var max = rail.scrollWidth - rail.clientWidth;
      /* -8 rather than 0: sub-pixel card widths leave a couple of px of slack
         at the end that would otherwise read as "not there yet" forever */
      var to = rail.scrollLeft >= max - 8 ? 0 : rail.scrollLeft + w;
      rail.scrollTo({ left: to, behavior: 'smooth' });
    }
    function start(){ if(!dead && !timer) timer = setInterval(tick, delay); }

    /*
      These used to call `kill` — one touch anywhere on the rail and the
      auto-advance was off for the rest of the session. On a phone that fires
      the moment a thumb lands on a card while scrolling PAST the section,
      which is why the top rail so often sat still while the lower one moved:
      nothing was wrong with it, it had just been touched first. Now the same
      gestures only hold it, and it resumes a few seconds after the reader
      stops interacting. `kill` still exists for the arrows, where an explicit
      click is a real statement of intent.
    */
    ['pointerdown','touchstart','wheel','keydown'].forEach(function(ev){
      rail.addEventListener(ev, function(){ held = performance.now() + 6000; }, { passive: true });
    });
    document.addEventListener('visibilitychange', function(){
      if(document.hidden) stop(); else start();
    });
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        seen = entries[0].isIntersecting;
        if(seen) start(); else stop();
      }, { threshold: .35 }).observe(rail);
    } else {
      seen = true;
    }
    start();
    return kill;
  }

  root.querySelectorAll('.po-vrail-w').forEach(function(wrap){
    var rail = wrap.querySelector('[data-vrail]');
    if(!rail) return;
    var prev = wrap.querySelector('[data-vnav="-1"]');
    var next = wrap.querySelector('[data-vnav="1"]');
    function step(){
      var card = rail.querySelector('.po-vid');
      return card ? card.getBoundingClientRect().width + railGap(rail) : rail.clientWidth / 2;
    }
    function sync(){
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if(prev) prev.hidden = rail.scrollLeft <= 2;
      if(next) next.hidden = rail.scrollLeft >= max;
    }
    var kill = autoRail(rail, '.po-vid', 4200);
    wrap.querySelectorAll('[data-vnav]').forEach(function(b){
      b.addEventListener('click', function(){
        if(kill) kill();
        rail.scrollBy({ left: step() * parseInt(b.getAttribute('data-vnav'), 10), behavior: 'smooth' });
      });
    });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ---------- review marquee ----------
     Now pure CSS (see the .po-fb-mq block in the stylesheet). The rAF loop
     that used to live here drove scrollLeft directly, which kept the row
     swipeable but gave the motion three separate ways to be switched off —
     rAF stops while the tab is hidden, the IntersectionObserver gate could
     stay false, and any touch parked it. It shipped standing still twice.
     A compositor animation has none of those gates, so there is no JS here
     any more. Same for the benefit cards. */

  /* ---------- compound disclosure ----------
     Collapsed on mobile only, and driven from JS rather than <details> so the
     desktop layout keeps the mechanism blocks in normal flow with no UA
     styling to unpick. [hidden] is added and removed as the query flips, so
     resizing a card open never leaves a panel stranded shut on desktop. */
  var compQ = window.matchMedia('(max-width:820px)');
  var compToggles = root.querySelectorAll('[data-comp-toggle]');
  function compApply(){
    compToggles.forEach(function(btn){
      var panel = root.querySelector('#' + btn.getAttribute('aria-controls'));
      if(!panel) return;
      if(compQ.matches){
        /* collapse on entry to mobile, but don't re-close one already opened */
        if(btn.getAttribute('aria-expanded') !== 'false' && !btn.dataset.touched){
          btn.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
        }
      } else {
        btn.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      }
    });
  }
  compToggles.forEach(function(btn){
    btn.addEventListener('click', function(){
      var panel = root.querySelector('#' + btn.getAttribute('aria-controls'));
      if(!panel) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.dataset.touched = '1';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
    });
  });
  if(compQ.addEventListener) compQ.addEventListener('change', compApply);
  else if(compQ.addListener) compQ.addListener(compApply);
  compApply();
  });

  safe('social-proof', function(){
  /* ---------- social proof toast ----------
     Shows a purchase card, hides it, waits, shows the next one. Rules that
     matter, in the order they bit:

     1. The first card waits `first` seconds after load — nothing else. An
        earlier version also waited on scroll; that read as considerate and
        performed as invisible.
     2. Names and places are drawn without repeating the previous pair, and the
        "x ago" stamp always moves forward within a card's own lifetime — a
        card that said "2 min ago" followed by one saying "20s ago" for the
        same store makes the whole strip read as fake.
     3. Dismiss is sticky for the session (sessionStorage, not localStorage):
        closing it means "not now", not "never again on any visit".
     4. It parks while the tab is hidden. setInterval keeps counting in a
        background tab, so a visitor returning after ten minutes would
        otherwise be met with a card mid-animation and a stale timestamp. */
  var el = root.querySelector('#po-proof');
  if(!el) return;

  var KEY = 'po-proof-dismissed';
  try { if(sessionStorage.getItem(KEY) === '1') return; } catch(e){}

  var split = function(v){
    return (v || '').split(/\s*[|\n]\s*/).map(function(s){ return s.trim(); }).filter(Boolean);
  };
  var names  = split(el.getAttribute('data-names'));
  var places = split(el.getAttribute('data-places'));
  if(!names.length || !places.length) return;

  var num = function(attr, dflt){
    var n = parseFloat(el.getAttribute(attr));
    return isFinite(n) && n > 0 ? n * 1000 : dflt;
  };
  var first = num('data-first', 2000);
  var gap   = num('data-gap', 2000);
  var hold  = num('data-hold', 7000);

  var nameEl  = el.querySelector('[data-proof-name]');
  var placeEl = el.querySelector('[data-proof-place]');
  var agoEl   = el.querySelector('[data-proof-ago]');
  var lift    = root.querySelector('#po-sticky');

  var lastName = -1, lastPlace = -1, timer = null, agoTimer = null, agoSecs = 0, dead = false;

  /* The sticky mobile ATC bar is only in flow while it carries .po-on, and it
     flips that class on scroll — which can happen while a card is already up.
     Measuring once at show() left the bar sitting on top of the card for the
     rest of its life, so the lift is re-applied whenever that class changes.
     On desktop the bar is display:none, so this measures 0 and the card keeps
     its normal 18px bottom offset. */
  function applyLift(){
    var h = (lift && lift.classList.contains('po-on')) ? lift.offsetHeight : 0;
    el.style.setProperty('--po-proof-lift', h + 'px');
  }
  if(lift && window.MutationObserver){
    new MutationObserver(applyLift).observe(lift, { attributes: true, attributeFilter: ['class'] });
  }

  /* pick(list, last) — never the same entry twice running. With a one-item
     list there is nothing to avoid, so it returns index 0 rather than looping. */
  function pick(list, last){
    if(list.length < 2) return 0;
    var i = last;
    while(i === last) i = Math.floor(Math.random() * list.length);
    return i;
  }

  /* the separator lives here rather than in a ::before so the card reads the
     same to a screen reader as it does on screen */
  function stamp(s){
    if(s < 60) return '\u00b7 ' + s + 's ago';
    var m = Math.floor(s / 60);
    return '\u00b7 ' + (m === 1 ? '1 min ago' : m + ' min ago');
  }

  function show(){
    if(dead) return;
    lastName  = pick(names, lastName);
    lastPlace = pick(places, lastPlace);
    nameEl.textContent  = names[lastName];
    placeEl.textContent = 'from ' + places[lastPlace];

    /* seed between 20s and ~4min so consecutive cards don't all open at the
       same number, then count up while the card is on screen */
    agoSecs = 20 + Math.floor(Math.random() * 220);
    agoEl.textContent = stamp(agoSecs);
    clearInterval(agoTimer);
    agoTimer = setInterval(function(){ agoSecs += 1; agoEl.textContent = stamp(agoSecs); }, 1000);

    applyLift();

    el.hidden = false;
    /* one frame between unhiding and flipping the flag, or the browser has
       nothing to transition FROM and the card appears without the slide */
    requestAnimationFrame(function(){ el.setAttribute('data-show', '1'); });
    timer = setTimeout(hide, hold);
  }

  function hide(){
    el.removeAttribute('data-show');
    clearInterval(agoTimer);
    /* keep it in the DOM until the fade finishes, then take it out of the
       a11y tree so a screen reader isn't parked on an invisible card */
    timer = setTimeout(function(){
      el.hidden = true;
      if(!dead) timer = setTimeout(show, gap);
    }, 400);
  }

  el.querySelector('[data-proof-close]').addEventListener('click', function(){
    dead = true;
    clearTimeout(timer); clearInterval(agoTimer);
    el.removeAttribute('data-show');
    setTimeout(function(){ el.hidden = true; }, 400);
    try { sessionStorage.setItem(KEY, '1'); } catch(e){}
  });

  document.addEventListener('visibilitychange', function(){
    if(document.hidden){ clearTimeout(timer); clearInterval(agoTimer); }
    else if(!dead && el.hidden){ timer = setTimeout(show, 2000); }
  });

  /* ?proof=now skips the delay — it exists so this can be checked in a
     preview or a screenshot without sitting through it. It only shortcuts the
     timing; everything the card shows is the real path. */
  if(new URLSearchParams(location.search).get('proof') === 'now'){ show(); return; }

  /* one gate: time. There used to be a second one — wait until the visitor had
     scrolled half a screen — but on a page whose whole job is urgency the card
     was landing long after the visitor had already decided. `first` is now the
     only thing between load and the first card. */
  setTimeout(function(){ if(!dead) show(); }, first);
  });
})();
